import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaLink } from '../../buttons';
import { CircularProgress } from '../../circularProgress';
import { useDynamicPercentage, useExpiryDateText, useRemainingValueText } from '../hooks';
import { WarrantyBaseProps } from '../types';

const useStyles = makeStyles({ name: 'WarrantyMedium-1' })(theme => ({
	root: {
		maxWidth: 580
	},
	panelContent: {
		display: 'flex',
		gap: 30
	},
	panelRight: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1
	},
	title: {
		fontWeight: 700,
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0.02em',
		marginBottom: 12
	},
	remainingPanel: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: '18px',
		lineHeight: '28px',
		letterSpacing: '0.02em',
		fontWeight: 700,
		gap: 8,
		marginBottom: 18
	},
	labelRemaining: {
		color: '#9E9FA0'
	},
	valueRemaining: {

	},
	panelBottom: {
		display: 'flex',
		gap: 18,
		justifyContent: 'space-between'
	},
	expiryDate: {
		fontSize: '16px',
		lineHeight: '24px',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap'
	},
	linkConditions: {
		fontSize: '12px',
		lineHeight: '12px',
		textAlign: 'end'
	},
	circularProgressLabel: {
		fontSize: '20px',
		lineHeight: '24px'
	}
}));

export const WarrantyMedium1 = (props: WarrantyBaseProps) => {
	const { translations, value, max, className, link } = props;
	const { classes, cx } = useStyles(null, { props });

	const dynamicValue = useDynamicPercentage(value, max);
	const remainingValueText = useRemainingValueText(props);
	const expiryDateText = useExpiryDateText(props);

	return (
		<div className={cx(classes.root, className)}>
			<div className={classes.panelContent}>
				<CircularProgress
					value={dynamicValue}
					variant='determinate'
					size={128}
					thickness={13}
					classes={{ circularProgressLabel: classes.circularProgressLabel }} />
				<div className={classes.panelRight}>
					{translations.title && <span className={classes.title}>{translations.title}</span>}
					<div className={classes.remainingPanel}>
						<span className={classes.labelRemaining}>{translations.remainingLabel}</span>
						<span className={classes.valueRemaining}>{remainingValueText}</span>
					</div>
					{(expiryDateText || link) &&
						<div className={classes.panelBottom}>
							{expiryDateText && <span className={classes.expiryDate}>{expiryDateText}</span>}
							{link && <SkodaLink href={link} target='_blank' className={classes.linkConditions}>{translations.linkConditions}</SkodaLink>}
						</div>}
				</div>
			</div>
		</div>
	);
};
